<div class="card d-flex flex-row align-items-center">
    <div class="card-custom flex-1 d-flex flex-column align-items-center justify-content-center" appDnd
         (fileDropped)="addFiles($event)">
        <div class="card-header">
            <span class="main-icon lg">
                <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M21.5 31.6001C20.7444 31.6001 20.1115 31.3441 19.6013 30.8321C19.0893 30.3218 18.8333 29.689 18.8333 28.9334V9.86673L13.8333 14.8667C13.3 15.4001 12.6778 15.6667 11.9667 15.6667C11.2555 15.6667 10.6111 15.3778 10.0333 14.8001C9.49999 14.2667 9.24488 13.633 9.26799 12.8987C9.28932 12.1663 9.54443 11.5556 10.0333 11.0667L19.6333 1.46673C19.9 1.20006 20.1889 1.01073 20.5 0.898731C20.8111 0.788509 21.1444 0.733398 21.5 0.733398C21.8555 0.733398 22.1889 0.788509 22.5 0.898731C22.8111 1.01073 23.1 1.20006 23.3667 1.46673L32.9667 11.0667C33.5 11.6001 33.7551 12.233 33.732 12.9654C33.7107 13.6996 33.4555 14.3112 32.9667 14.8001C32.4333 15.3334 31.8004 15.6107 31.068 15.6321C30.3338 15.6552 29.7 15.4001 29.1667 14.8667L24.1667 9.86673V28.9334C24.1667 29.689 23.9115 30.3218 23.4013 30.8321C22.8893 31.3441 22.2555 31.6001 21.5 31.6001ZM5.49999 42.2667C4.03332 42.2667 2.77821 41.745 1.73466 40.7014C0.689323 39.6561 0.166656 38.4001 0.166656 36.9334V31.6001C0.166656 30.8445 0.421768 30.2107 0.93199 29.6987C1.44399 29.1885 2.07777 28.9334 2.83332 28.9334C3.58888 28.9334 4.22266 29.1885 4.73466 29.6987C5.24488 30.2107 5.49999 30.8445 5.49999 31.6001V36.9334H37.5V31.6001C37.5 30.8445 37.756 30.2107 38.268 29.6987C38.7782 29.1885 39.4111 28.9334 40.1667 28.9334C40.9222 28.9334 41.5551 29.1885 42.0653 29.6987C42.5773 30.2107 42.8333 30.8445 42.8333 31.6001V36.9334C42.8333 38.4001 42.3115 39.6561 41.268 40.7014C40.2227 41.745 38.9667 42.2667 37.5 42.2667H5.49999Z"
                      fill="#005780"/>
                </svg>
            </span>
        </div>
        <div class="card-body flex-none d-flex flex-column align-items-center justify-content-center">
            <h4 class="card-title">
                Arraste os arquivos aqui<br/>ou
            </h4>
            <div class="d-flex gap-10 align-items-center">
                <ui-button
                    variant="outline"
                    color="secondary"
                    [disabled]="isMaxArquivos"
                    (click)="uploadFile(inputUploadFiles)"
                >
                    Escolher arquivo
                </ui-button>

                @if (isMaxArquivos) {

                    <ui-button
                        color="secondary"
                        pTooltip="Limite de arquivos atingido"
                    >
                        <i class="fas fa-exclamation"></i>
                    </ui-button>
                }
                <input type="file" id="inputUploadFiles" class="hidden" #inputUploadFiles multiple
                       [disabled]="isMaxArquivos"
                       maxlength="2" (change)="addFiles($event)" [accept]="getExtensoesPermitidasInput()"/>
            </div>
        </div>
    </div>
    <div class="card-side flex-1" [ngStyle]="{ 'width.px': (filesArray && filesArray.length > 0) ? '288' : '30' }">

        @if (filesArray && filesArray.length > 0) {
            <div>
                <ul class="file-list">

                    @for (file of filesArray; track file) {
                        <li>
                            <span class="file-data">

                                <p class="file-name" title="{{ file.name }}">
                                    {{ file.name }}
                                </p>

                                <div class="file-info-bottom overflow-hidden">
                                    <p class="file-size">
                                        {{ formatBytes(file.size) }}
                                    </p>

                                    <span class="remove-file">
                                        <i class="flaticon2-cross" (click)="removeFile(file)"></i>
                                    </span>
                                </div>

                            </span>
                        </li>
                    }

                </ul>
            </div>
        }
    </div>
</div>
